export var RECEIVED_BOOKMARK_LISTS = "RECEIVED_BOOKMARK_LISTS";
export var RECEIVED_NEW_LIST_AND_BOOKMARK = "RECEIVED_NEW_LIST_AND_BOOKMARK";
export var RECEIVED_NEW_BOOKMARK = "RECEIVED_NEW_BOOKMARK";
export var RECEIVED_UPDATED_BOOKMARK = "RECEIVED_UPDATED_BOOKMARK";
export var RECEIVED_USER_LOGIN = "RECEIVED_USER_LOGIN";
export var RECEIVED_NEARBY_POIS = "RECEIVED_NEARBY_POIS";



//////////////////
// WEBPACK FOOTER
// ./app/modules/pois/actions/actionTypes.ts
// module id = JHeX
// module chunks = 2